module.exports = __webpack_public_path__ + "img/gitlab.3458c112.svg";